import { render, staticRenderFns } from "./paidorderconsumablerecord.vue?vue&type=template&id=01019346&"
import script from "./paidorderconsumablerecord.vue?vue&type=script&lang=js&"
export * from "./paidorderconsumablerecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports